import { testimonials } from "@/mocks/testimonials";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";

const PRINCIPLES = [
  { title: "只做整理，不下判断", desc: "呈现公开讨论的脉络与分歧，把结论留给每一位读者。" },
  { title: "标注来源与时间", desc: "每条话题都保留时间与出处线索，方便你回溯与核对。" },
  { title: "热度会随时间回落", desc: "不制造焦虑，也不无限放大，让热度自然升温与降温。" },
];

export default function VoiceSection() {
  return (
    <section id="voice" className="scroll-mt-20 bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <Reveal>
        <SectionHeading
          eyebrow="About & Voices"
          title="关于网曝吃瓜，以及大家怎么说"
          description="我们想做的不是又一个热闹的榜单，而是一个能让人快速看清脉络、又愿意理性发言的围观场所。"
        />
      </Reveal>

      <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
        <Reveal className="lg:col-span-1">
          <div className="flex h-full flex-col rounded-lg bg-foreground-950 p-6 md:p-7">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-xl" aria-hidden="true" />
            </span>
            <h3 className="mt-5 font-heading text-xl font-bold text-background-50">
              网曝吃瓜 · 热点围观现场
            </h3>
            <p className="mt-3 text-xs leading-relaxed text-background-200 md:text-sm">
              我们把分散在各处的热门讨论聚到同一张页面上，让热搜、话题与现场评论彼此对照。目标是让「围观」变得更有信息量，也更克制。
            </p>
            <dl className="mt-6 space-y-4">
              {PRINCIPLES.map((item) => (
                <div key={item.title} className="flex gap-3">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-accent-400" aria-hidden="true" />
                  <div>
                    <dt className="text-xs font-medium text-background-50 md:text-sm">
                      {item.title}
                    </dt>
                    <dd className="mt-0.5 text-[11px] leading-relaxed text-background-300 md:text-xs">
                      {item.desc}
                    </dd>
                  </div>
                </div>
              ))}
            </dl>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-2">
          {testimonials.map((item, index) => (
            <Reveal key={item.name} delay={index * 60}>
              <figure className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                <i className="ri-double-quotes-l text-2xl text-primary-300" aria-hidden="true" />
                <blockquote className="mt-3 flex-1 text-xs leading-relaxed text-foreground-700 md:text-sm">
                  {item.content}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 font-heading text-sm font-bold text-accent-900">
                    {item.initial}
                  </span>
                  <span>
                    <span className="block text-xs font-medium text-foreground-900">
                      {item.name}
                    </span>
                    <span className="block text-[11px] text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}